import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import moment from 'moment';
import * as actions from './redux/actions';
import thirtyFourALogo from '../../34a.png';
import gsskLogo from '../../gssk.png';
import {Link} from "react-router-dom";

export class DefaultPage extends Component {
    static propTypes = {
        home: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        exerciseStatistics: PropTypes.array,
        loginStatistics: PropTypes.array,
    };

    static defaultProps = {
        exerciseStatistics: [],
        loginStatistics: [],
    };

    render() {
        if (this.props.home.loginPending) return null;
        const {home: { customers }} = this.props;
        return (
            <div className="content-animate">
                <h1>Übersicht</h1>
                {this.props.home.isApplicationReady ? (
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Ihre Produkte</h3>
                            <div className="row">
                                <div className="col-md-4 col-sm-6 col-xs-12">
                                    <div className="card">
                                        <div className="card-img-top">
                                            <img src={thirtyFourALogo} alt="34aLogo"/>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">34a</h5>
                                            <Link to={`products/2`} className="btn btn-primary">
                                                <span>Statistik Ansehen</span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 col-xs-12">
                                    <div className="card">
                                        <div className="card-img-top">
                                            <img src={gsskLogo} alt="gsskLogo"/>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">GSSK</h5>
                                            <Link to={`products/5`} className="btn btn-primary">
                                                <span>Statistik Ansehen</span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="lds-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    </div>
                    )}
                <h3>Aktive Nutzer</h3>
                {!this.props.home.fetchLicensesPending && (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <td>Name</td>
                                        <td>Produkt</td>
                                        <td>Lizenzdauer</td>
                                        <td>Lizenz</td>
                                        <td>Lizenz gültig bis</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {customers && customers.map(license => {
                                        return license.status === '1' ? (
                                            <tr key={JSON.stringify(license)}>
                                                <td><Link to={`products/${license.product_id}/${license.user_id}`} >{license.first_name} {license.last_name}</Link></td>
                                                <td>{license.name}</td>
                                                <td>{license.activated && `${license.activated} Monate`}</td>
                                                <td className={license.status === '1' ? 'bg-success text-white' : 'bg-danger text-white'}>{moment().isBefore(moment(license.expires)) ? 'Aktiviert' : 'Deaktiviert'}</td>
                                                <td>{license.expires}</td>
                                            </tr>
                                        ) : null
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        home: state.home,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({...actions}, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js